import { JetView } from 'webix-jet'; // Importing JetView from webix-jet
import { devConfig } from 'config/config'; // Importing devConfig for configuration settings

/**
 * Class representing a view for generating tokens with filters.
 */
export default class FilterGenerateTokenView extends JetView {
    /**
     * Configures the UI components of the view.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const screen = this.app.config.size; // Screen size configuration

        // Configuration for the left section containing a date picker
        const center_left = {
            margin: 5,
            rows: [
                {
                    view: 'text',
                    name: 'Datepicker',
                    id: 'Datepicker',
                    css: 'reportrange',
                    readonly: true,
                    label: "<span class='webix_icon icon-calendar'></span>" + _('Fecha'), // Label for the date picker
                    labelPosition: 'top',
                    placeholder: _('Click para seleccionar '), // Placeholder text
                },
            ],
        };

        // Configuration for the right section (currently empty)
        const center_right = {
            margin: 5,
            rows: [],
        };

        // Configuration for the right section (currently empty)
        const right = {
            margin: 5,
            rows: [],
        };

        // Upper section layout combining left and a spacer
        const upper_section = {
            cols: [
                center_left,
                { gravity: 1, minWidth: 10 }, // Spacer
            ],
        };

        // Configuration for buttons at the bottom of the form
        const buttons = {
            margin: 0,
            cols: [
                {},
                {
                    view: 'button',
                    value: _('Crear Token Personalizado'), // Button to create a custom token
                    width: 120,
                    hidden: !devConfig.getPermAction(
                        'betShopConfigurationGenerateTokenAdd',
                        'Add', // Permission check for button visibility
                    ),
                    css: 'prm-betShopConfigurationGenerateTokenAdd',
                    click: () => {
                        this.app.callEvent('createToken:button', [[]]); // Event to create a token
                    },
                },
                {
                    view: 'button',
                    value: _('Generar Token'), // Button to generate a token
                    width: 120,
                    hidden: !devConfig.getPermAction(
                        'betShopConfigurationGenerateTokenAdd',
                        'Add', // Permission check for button visibility
                    ),
                    css: 'prm-betShopConfigurationGenerateTokenAdd',
                    click: () => {
                        const cur_user = this.getParam('user', true); // Get current user ID
                        const filterdata = this.getRoot().getValues(); // Get form values
                        var thisClich = this; // Reference to the current context
                        webix
                            .ajax()
                            .headers({
                                'Content-type': 'application/json', // Set content type for the request
                            })
                            .post(
                                devConfig.geturlApi() + '/UserManagement/SaveUserSecurity', // API endpoint
                                '{ "UserId":' + cur_user + '}', // Request body
                                {
                                    error: function (text, data, XmlHttpRequest) {
                                        webix.message(_('Error')); // Error message on failure
                                    },
                                    success: function (text, data, XmlHttpRequest) {
                                        var json = JSON.parse(text); // Parse response
                                        webix.message(_('Guardado')); // Success message
                                        thisClich.app.callEvent(
                                            'generateTokenBetShop:filter',
                                            [filterdata], // Trigger filter event
                                        );
                                    },
                                },
                            );
                    },
                },
                {
                    view: 'button',
                    value: _('Limpiar'), // Button to clear the form
                    width: 66,
                    click: () => {
                        this.getRoot().clear(); // Clear form values
                    },
                },
                {
                    view: 'button',
                    value: _('Consultar'), // Button to consult/filter
                    hotkey: 'enter', // Shortcut key
                    type: 'form',
                    width: 84,
                    click: () => {
                        const filterdata = this.getRoot().getValues(); // Get form values
                        this.app.callEvent('generateTokenBetShop:filter', [
                            filterdata, // Trigger filter event
                        ]);
                    },
                },
            ],
        };

        // Return the complete form configuration
        return {
            view: 'form',
            rows: [upper_section, buttons], // Combine upper section and buttons
            rules: {
                fname: webix.rules.isNotEmpty, // Validation rule for form fields
            },
        };
    }

    /**
     * Initializes the view and sets up event listeners.
     * @param {Object} grid - The grid component.
     */
    init(grid) {
        const _ = this.app.getService('locale')._; // Localization service
        var vthis = this; // Reference to the current context

        // Configuration for the popup window to create a token
        var popupAdd = webix.ui({
            view: 'window',
            id: 'CreateToken',
            head: {
                view: 'toolbar',
                cols: [
                    { view: 'label', label: _('Crear Token') }, // Window title
                    {
                        view: 'icon',
                        icon: 'wxi-close', // Close icon
                        click: function () {
                            this.getTopParentView().hide(); // Close the popup
                        },
                    },
                ],
            },
            position: 'center', // Center the window
            modal: true, // Make the window modal
            body: {
                view: 'form',
                id: 'addform', // Form ID
                elements: [
                    {
                        view: 'combo',
                        label: _('Tipo'), // Label for type selection
                        name: 'Type',
                        options: [{ id: '2', value: _('Box') }], // Options for the combo
                        required: true, // Mark as required
                    },
                    {
                        view: 'textarea',
                        name: 'Token', // Name for the token input
                        label: _('Token'), // Label for the token input
                        labelPosition: 'top',
                        placeholder: _('Token'), // Placeholder text
                        required: true, // Mark as required
                    },
                    {
                        cols: [
                            {
                                view: 'button',
                                value: _('Cancelar'), // Cancel button
                                click: function () {
                                    this.getTopParentView().hide(); // Close the popup
                                    $$('addform').setValues(
                                        $$('addform').getCleanValues(), // Reset form values
                                    );
                                },
                            },
                            {
                                view: 'button',
                                type: 'form',
                                value: _('Guardar'), // Save button
                                click: function ($e) {
                                    var values = $$('addform').getValues(); // Get form values
                                    const cur_user = vthis.getParam(
                                        'user',
                                        true, // Get current user ID
                                    );
                                    var vthis2 = this; // Reference to the current context
                                    if ($$('addform').validate()) {
                                        // Validate form
                                        webix
                                            .ajax()
                                            .headers({
                                                'Content-type': 'application/json', // Set content type for the request
                                            })
                                            .post(
                                                devConfig.geturlApi() + '/UserManagement/SaveUserSecurityTokenCustom', // API endpoint
                                                '{"UserId":"' +
                                                    cur_user +
                                                    '","Type":"' +
                                                    values.Type +
                                                    '", "Token":"' +
                                                    values.Token +
                                                    '"}', // Request body
                                                {
                                                    error: function (text, data, XmlHttpRequest) {
                                                        webix.message(
                                                            'Error! ', // Error message on failure
                                                        );
                                                    },
                                                    success: function (text, data, XmlHttpRequest) {
                                                        webix.message(
                                                            _('Token Creado'), // Success message
                                                        );
                                                        $$('addform').setValues(
                                                            $$('addform').getCleanValues(), // Reset form values
                                                        );
                                                        vthis2.getTopParentView().hide(); // Close the popup
                                                    },
                                                },
                                            );
                                    } else {
                                        webix.message({
                                            title: '¡Error!', // Error title
                                            type: 'alert-error',
                                            text: _('Completa los campos...'), // Error message
                                        });
                                    }
                                },
                            },
                        ],
                    },
                ],
                elementsConfig: {
                    on: {
                        onChange: function () {
                            this.validate(); // Validate fields on change
                        },
                    },
                },
            },
        });

        // Event listener for creating a token
        this.on(this.app, 'createToken:button', (filter) => {
            popupAdd.show(); // Show the popup
            $$('addform').clearValidation(); // Clear previous validation
        });
    }
}

// FILE DOCUMENTED
